import React, { useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { login } from "../../api/auth";

function LoginForm({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("");
    setLoading(true);

    try {
      const tokens = await login(username, password);
      setStatus("Login successful!");

      // Persist session info
      localStorage.setItem("username", username);

      if (onLogin) onLogin(tokens);

    } catch (error) {
      console.error("Login error:", error);
      setStatus("Login failed. Check username and password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <Stack spacing={0.75}>
          <Typography variant="subtitle2" sx={{ color: "text.primary", fontWeight: 700 }}>
            Username
          </Typography>
          <TextField
            type="text"
            name="username"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            fullWidth
            placeholder="Enter your username"
            InputProps={{
              sx: {
                borderRadius: 2,
                backgroundColor: "rgba(255,255,255,0.9)",
              },
            }}
          />
        </Stack>

        <Stack spacing={0.75}>
          <Typography variant="subtitle2" sx={{ color: "text.primary", fontWeight: 700 }}>
            Password
          </Typography>
          <TextField
            type="password"
            name="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
            placeholder="Enter your password"
            InputProps={{
              sx: {
                borderRadius: 2,
                backgroundColor: "rgba(255,255,255,0.9)",
              },
            }}
          />
        </Stack>

        {status ? (
          <Alert severity={status === "Login successful!" ? "success" : "error"} sx={{ borderRadius: 2 }}>
            {status}
          </Alert>
        ) : null}

        <Button
          type="submit"
          variant="contained"
          size="large"
          disabled={loading || !username || !password}
          sx={{
            mt: 0.5,
            borderRadius: 999,
            py: 1.35,
            textTransform: "none",
            fontWeight: 700,
            boxShadow: "0 16px 28px rgba(27, 64, 111, 0.22)",
          }}
        >
          {loading ? <CircularProgress size={18} sx={{ color: "inherit", mr: 1 }} /> : null}
          {loading ? "Signing in..." : "Log in"}
        </Button>
      </Stack>
    </form>
  );
}

export default LoginForm;
